import {
  deleteRequest,
  get,
  patch,
  post,
  put,
} from "services/BaseClient/Client";
import headers from "services/BaseClient/Headers.json";
import { DataResponse } from "services/BaseClient/BaseResponseModel";
import endpoints from "./EndPoints";


export const getStoreListFilter = async (): Promise<DataResponse<any>> => {
  // const query = CreateUrlFilter(filter)
  const url = `${endpoints.getStoreListFilter}`;

  const config = headers.content_type.application_json;
  return get<DataResponse<any>>(url, config);
};
export const getStoreByUser =()=>{
  const url = `${endpoints.getStoresByUser}`;
  const config = headers.content_type.application_json;
  return get<DataResponse<any>>(url, config);
}
export const getTaxtCertificateList= async (storeId:string): Promise<DataResponse<any>> => {
  const url = `${endpoints.getTaxCertificates}/${storeId}`;
  const config = headers.content_type.application_json;
  return get<DataResponse<any>>(url, config);
};

export const getStoreDetails = async (
  storeId: string
): Promise<DataResponse<any>> => {
  const url = `${endpoints.getStoreDetails}/${storeId}`;
  const config = headers.content_type.application_json;
  return get<DataResponse<any>>(url, config);
};

export const addStore = async (data: any): Promise<DataResponse<any>> => {
  const url = `${endpoints.addStore}`;
  const config = headers.content_type.application_json;
  return post<DataResponse<any>>(url, data, config);
};

export const addTaxCertificate = async (data: any): Promise<DataResponse<any>> => {
  const url = `${endpoints.addTaxCertificate}`;
  const config = headers.content_type.multipart_form_data;
  return post<DataResponse<any>>(url, data, config);
};
export const addImageByStore = async (
  data: any
): Promise<DataResponse<any>> => {
  const url = `${endpoints.addImageByStore}`;
  const config = headers.content_type.multipart_form_data
  return post<DataResponse<any>>(url, data, config);
};
export const updateStoreWithPut = async (
  data: any
): Promise<DataResponse<any>> => {
  const url = `${endpoints.updatStoreWithPut}`;
  const config = headers.content_type.application_json;
  return put<DataResponse<any>>(url, data, config);
};
export const updateStoreWithPatch = async (
  data: any
): Promise<DataResponse<any>> => {
  const url = `${endpoints.updateStoreWithPatch}`;
  const config = headers.content_type.application_json;
  return patch<DataResponse<any>>(url, data, config);
};
export const deleteStore = async (data: any): Promise<DataResponse<any>> => {
  const url = `${endpoints.deleteStore}/${data.id}`;
  const config: any = headers.content_type.application_json;
  return deleteRequest<DataResponse<any>>(url, data, config);
};
export const deleteTaxCertificate = async (data: any): Promise<DataResponse<any>> => {
  const url = `${endpoints.deleteTaxtCertificate}/${data.id}`;
  const config: any = headers.content_type.application_json;
  return deleteRequest<DataResponse<any>>(url, data, config);
};
